<template>
  <article v-if="$marketing.showAdvertising">
    <div
      :class="['wrap-ad wrap-monetization-ad card', { 'with-close': withClose }]"
      :style="[hasMargin ? { '--card-margin-bottom': `${marginValue}` } : { '--card-margin-bottom': 'margin-bottom-0' }]"
    >
      <div class="monetization-ad text-left size-sm">
        <span class="sr-only">Advertisement</span>
        <div :class="placementClass" />
      </div>

      <button
        v-if="withClose"
        type="button"
        aria-label="Remove Ad"
        data-balloon-pos="left"
        class="close"
        style="--with-close-close-color: var(--fa-dk-violet)"
        @click.prevent="showRemoveAdsModal"
      >
        <font-awesome-icon :icon="$v6.duotone.faCircleXmark" />
      </button>
    </div>

    <wa-modal-upsell
      :is-showing="isShowingRemoveAdsModal"
      upsell-requirement="Pro plan"
      upsell-trigger="Removing all third-party advertisements"
      upsell-trigger-icon-name="faBillboard"
      @close-modal="hideRemoveAdsModal"
    />
  </article>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid'
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'MonetizationAd',

    mixins: [EventTrackingMixin],

    props: {
      hasMargin: {
        type: Boolean,
        default: false
      },

      marginValue: {
        type: String,
        default: 'var(--spacing-3xl)'
      },

      placementName: {
        type: String
      },

      withClose: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        placementClass: `wildings-${uuidv4()}`,
        isShowingRemoveAdsModal: false,
        zoneId: 'CKYD623M'
      }
    },

    computed: {
      componentStyle() {
        let style = {}

        if (this.hasMargin) {
          style['--card-margin-bottom'] = `${this.marginValue}`
        }

        if (!this.hasMargin) {
          style['--card-margin-bottom'] = '0'
        }

        return {
          ...style
        }
      },

      placement() {
        return this.placementName || `placement:${uuidv4()}`
      }
    },

    mounted() {
      if (typeof _bsa !== 'undefined' && _bsa) {
        _bsa.init('default', 'CVAIKK7M', `${this.placement}`, {
          target: `.${this.placementClass}`,
          align: 'horizontal',
          disable_css: true,
          forceReload: true
        })
      }
    },

    methods: {
      showRemoveAdsModal() {
        const skipModal = this.$posthog.getFeatureFlag('skip-pro-modal-go-to-plans-pro') === 'skip-modal'

        this.purchaseFlowEvent('upsell_click')

        if (skipModal) {
          window.location.replace('/plans/pro')
        } else {
          this.purchaseFlowEvent('remove_ads_modal_view', {
            context: 'monetization_ad'
          })
          this.isShowingRemoveAdsModal = true
        }
      },

      hideRemoveAdsModal() {
        this.isShowingRemoveAdsModal = false
      }
    }
  }
</script>
